// @flow

import { type Address } from './types';

export function getState(address: Address): string {
  return address['state'] || '';
}
